import { render } from "./PrivacyView.vue?vue&type=template&id=ef32885a&scoped=true"
const script = {}

import "./PrivacyView.vue?vue&type=style&index=0&id=ef32885a&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef32885a"]])

export default __exports__